import { I18n } from '@calendly/i18n'
import { useSelector, useDispatch } from 'react-redux'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import {
  isFilteringSelector,
  filterTermSelector,
  usersSelector,
  hasMoreUsersSelector
} from 'selectors/home_bar'

import AllScope from './all_scope'
import Header from './header'
import Item from './item'
import MenuGroup from './menu_group'
import ShowMore from './show_more'

const UserGroupList = ({ selectItem, userGroup }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const users = useSelector(usersSelector)
  const hasMoreUsers = useSelector(hasMoreUsersSelector)
  const showHeader = !isFiltering || users.length > 0
  const showAllScope = !isFiltering
  const userGroupName = userGroup.name
  const userGroupId = userGroup.id
  const headerTitle = I18n.t('publisher.title.users_in_group', { name: userGroupName })
  const allScopeTitle = I18n.t('publisher.title.all_users_in_group', { name: userGroupName })
  const onAllScopeClick = () => selectItem('user_group', userGroupId)

  return (
    <MenuGroup data-component="scope-dropdown-user-list">
      {showHeader && (
        <Header title={headerTitle} />
      )}
      {showAllScope && (
        <AllScope
          title={allScopeTitle}
          onClick={onAllScopeClick}
        />
      )}
      {users.map(({ id, name, ...item }) => (
        <Item
          key={id}
          itemId={id}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          onClick={() => selectItem('user_single', id)}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreUsers && <ShowMore onClick={() => dispatch(loadMoreData('users'))} />}
    </MenuGroup>
  )
}

export default UserGroupList
